import http from './http'

export function fetchNoticeList(site = 'default') {
  return http.get('/api/notice/list', { params: { site } })
}
